import React from 'react';
import { Grid, Button, CircularProgress } from '@material-ui/core'
import { Field } from 'redux-form'

import { Input, Autocomplete } from 'components'

const renderField = (name, label) => (
  <Field
    fullWidth
    name={name}
    label={label}
    margin='normal'
    component={Input}
  />
)

export const AddWaitingPassengerForm = props => (
  <Grid
    container
    spacing={16}
    wrap='nowrap'
    component='form'
    alignItems='center'
    onSubmit={props.handleSubmit(props.setWaitingPassenger)}
  >
    <Grid item>
      {renderField('surname', 'Прізвище')}
    </Grid>
    <Grid item>
      {renderField('name', 'Імя')}
    </Grid>
    <Grid item>
      {renderField('phone', 'Телефон')}
    </Grid>
    <Grid item>
      <Autocomplete
        name='from'
        label='Звідки'
        value={props.from}
        form='AddWaitingPassenger'
        suggestion={props.routeCities}
      />
    </Grid>
    <Grid item>
      <Autocomplete
        name='to'
        label='Куди'
        value={props.from}
        form='AddWaitingPassenger'
        suggestion={props.routeCities}
      />
    </Grid>
    <Grid item>
      <Button
        type='submit'
        color='primary'
        variant='contained'
        disabled={props.isLoading}
        className={props.classes.addButton}
      >
        Добавити
        {props.isLoading && (
          <CircularProgress size={24} className={props.classes.buttonProgress} />
        )}
      </Button>
    </Grid>
  </Grid>
);



// WEBPACK FOOTER //
// ./src/components/AddWaitingPassengerForm/AddWaitingPassengerForm.js